<div class="container">
  <div class="actions" (click)="this.clickIn()">
    <!-- Notifications will probably come back -->
    <!-- <div class="notifications">
      <mat-icon svgIcon="notification"></mat-icon>
    </div> -->

    <div class="profile" [matMenuTriggerFor]="profileMenu">
      <ng-template #avatarButton>
        <button class="avatar-button icon-button">
          {{ name == undefined || name.length === 0 ? "A" : name.charAt(0) | uppercase }}
        </button>
      </ng-template>
      <ng-container *ngTemplateOutlet="avatarButton"></ng-container>

      <div class="name">
        <ng-template #username>
          <span class="username inter-font">{{name == undefined || name.length === 0 ? "Anonymous" : name | titlecase}}</span>
        </ng-template>
        <ng-container *ngTemplateOutlet="username"></ng-container>
      </div>

      <mat-icon class="arrow-down">keyboard_arrow_down</mat-icon>
    </div>

    <mat-menu #profileMenu="matMenu" class="profile-menu">
      <div class="user-data">
        <div class="user-info">
          <ng-container *ngTemplateOutlet="avatarButton"></ng-container>

          <div class="name">
            <ng-container *ngTemplateOutlet="username"></ng-container>
            <span class="usermail">{{ mail }}</span>
          </div>
        </div>

        <div class="user-actions">
          <a mat-menu-item class="settings" (click)="openSettingsModal()">
            <span class="material-icons">settings</span>
            <span class="text">Settings</span>
          </a>
          <a mat-menu-item class="logout" (click)="logout()">
            <span class="material-icons">input</span>
            <span class="text">Log Out</span>
          </a>
        </div>
      </div>
    </mat-menu>
  </div>
</div>